<template>
    <div class="supplier-report-container">
        <div class="t-top-bar">
            <div class="report-op">
              <el-select id="supplierSelect" filterable clearable class="search-input" v-model="supplierId" placeholder="选择客户">
                <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
              </el-select>
              <el-select id="productionSelect" filterable clearable class="search-input" v-model="productionId" @change="productionChange" placeholder="选择产品">
                <el-option v-for="(val,key) in productionList" :key="key" :label="val.productionName" :value="val.productionId"></el-option>
              </el-select>
              <el-select id="specSelect" filterable clearable class="search-input" v-model="specId" placeholder="选择规格">
                <el-option v-for="(val,key) in specList" :key="key" :label="val.specName" :value="val.specId"></el-option>
              </el-select>
              <el-select id="tecSelect" filterable clearable class="search-input" v-model="tecId" placeholder="选择工艺">
                <el-option v-for="(val,key) in tecList" :key="key" :label="val.technologyName" :value="val.technologyId"></el-option>
              </el-select>
              <el-date-picker style="margin-right: 15px;"  v-model="selectTime" type="datetimerange"
                               range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
            </div>
            <div class="report-op"><el-button type="primary" @click="search">搜索</el-button></div>
            <div class="report-op"><el-button type="primary"  @click="print">打印</el-button></div>
            <div class="report-op"><el-button style="margin: 0" type="primary"  @click="edit">修改</el-button></div>
            <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%" :span-method="arraySpanMethod"
                  @selection-change="selectionChange" v-loading="listLoading">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="supplier_name" label="供货商"></el-table-column>
          <el-table-column prop="production_name" label="产品"></el-table-column>
          <el-table-column prop="technology_name" label="工艺"></el-table-column>
          <el-table-column prop="spec_name" label="规格"></el-table-column>
          <el-table-column prop="dispatch_kg" label="重量(kg)"></el-table-column>
          <el-table-column prop="price" label="单价(元)"></el-table-column>
          <el-table-column prop="total_price" label="总价"></el-table-column>
          <el-table-column prop="record_time" label="记录时间" width="180">
            <template slot-scope="scope">
              {{scope.row.record_time | formateTime()}}
            </template>
          </el-table-column>
          <el-table-column prop="report_time" label="上传时间" width="180">
            <template slot-scope="scope">
              {{scope.row.record_time | formateTime()}}
            </template>
          </el-table-column>
          <el-table-column prop="equipment_id" label="设备编号" width="100"></el-table-column>
        </el-table>
      <el-dialog title="记录修改" @close="editCloseHandler" :visible.sync="editDialogVisiable" width="650px">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="重量(kg)" prop="weight" :label-width="formLabelWidth">
            <el-input v-model="editForm.weight" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisiable = false">取 消</el-button>
          <el-button type="primary" @click="editConfirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
    import { getSupplierRecord } from '../../api/record'
    import { tableDataToExcelSample, dataprint} from '../../util/util'
    import { getProductionList } from '../../api/prouction'
    import { getSupplierList } from '../../api/supplier'
    import { getSpecList } from '../../api/spec'
    import { getTechnologyList } from '../../api/technology'
    import localCache from "../../util/localCache";
    import { editSupplierRecord } from '../../api/recordEdit'
    import {addPrice, updatePrice} from "@/api/supplierPrice";

    export default {
        name: "supplierStatisticsReportContainer",
        data(){
          let reg = /^\d{0,5}\.?\d{0,2}$/
          let checkPrice = (rule, value, callback) => {
            if(value === ''){
              callback(new Error('请输入数字值'));
            }
            if (!reg.test(''+value)) {
              callback(new Error('请输入合法数值'));
            } else {
              if (value < 0 || value > 99999) {
                callback(new Error('数值范围0-99999'));
              } else {
                callback();
              }
            }
          }
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                reportColumn: {
                  'total_price': '工资',
                  // 'calc_kg': '计价重量',
                  // 'delivery_kg': '交料重量'
                },
                selectColumn: 'total_price',
                pns:{
                  '剥虾':'剥虾',
                  '去头':'去头'
                },
                pn: '剥虾',
                selectTime: '',
                keyword: '',
                searchDepart:'',
                treeData: [],
                priceType:'',
                supplierId: '',
                supplierList: [],
              productionId: '',
              specId: '',
              tecId: '',
              productionList: [],
              specList:[],
              tecList:[],
              columnsNum: 10,
              columns: [],
              selectOrderId: [],
              orderIdArr: [],
              selectRows: [],
              formLabelWidth: '80px',
              editDialogVisiable: false,
              editForm:{
                weight: ""
              },
              rules:{
                weight: [
                  { required: true,validator: checkPrice, trigger: 'blur' }
                ]
              }
            }
        },
        mounted(){
          let now = new Date()
          let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
          this.selectTime = [end,now]

          this.generateColumn()
          this.getProductionList_();
          this.getSupplierList_();
        },
        methods: {
          editCloseHandler(){
            this.$refs['editForm'].resetFields()
            this.editForm = {
              weight: ""
            }
          },
          productionChange(val){
            console.log(val)
            this.specId=''
            this.tecId=''
            let param = {
              customerId: localCache.getCurrentCustomerId()
            }
            if(val){
              param.productionId = val
            }
            getSpecList(param).then(res => {
              this.listLoading = false
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.specList = res.data
              }
            }).catch(() => {

            })
            param.type = 4
            getTechnologyList(param).then(res => {
              this.listLoading = false
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.tecList = res.data
              }
            }).catch(() => {

            })
          },
          generateColumn(){
            let arr = []
            for (let i = 0; i < this.columnsNum; i++) {
              arr.push({
                name: ''+(i+1),
                key: 'c'+i
              })
            }
            this.columns = arr
          },
          getProductionList_(){
            getProductionList({
              customerId: localCache.getCurrentCustomerId()
            }).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.productionList = res.data
              }
            }).catch(() => {
            })
          },
          getSupplierList_(){
            let param = {
              customerId: localCache.getCurrentCustomerId(),
            }
            getSupplierList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.supplierList = res.data
              }
            }).catch(() => {
            })
          },
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            let selectProduction = document.getElementById('productionSelect').value
            let selectSupplier = document.getElementById('supplierSelect').value
            let date = new Date(this.selectTime[0])
            let time = `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`
            dataprint(printHTML)
          },
          edit(){
            if(this.selectRows.length == 0){
              this.$message.error('请选择要修改的记录')
              return
            }
            this.editDialogVisiable  =true
          },
          editConfirm(){
            this.$refs['editForm'].validate((valid) => {
              if (!valid) {
                return
              }
              let param = Object.assign({}, this.editForm)
              param.customerId = localCache.getCurrentCustomerId()
              param.ids = this.selectRows.map(t=>t.record_id).join(",")

              editSupplierRecord(param).then((res)=>{
                if(res.errorcode==0){
                  this.$message.success('修改成功')
                  this.editDialogVisiable = false
                  this.getRecordList_()
                }else{
                  this.$message.error(res.message)
                }
              })
            });
          },
          arraySpanMethod({ row, column, rowIndex, columnIndex }){
            if(row.last){
              if(columnIndex == 0){
                return row.span
              }else if(columnIndex>0 && columnIndex <= this.columnsNum){
                return {
                  rowspan: 1,
                  colspan: 0
                }
              }
              return {
                rowspan: 1,
                colspan: 1
              }
            }
            if(columnIndex == 0 || columnIndex>this.columnsNum){
              if(row.span){
                return row.span
              }
            }
          },
            exportExcel(){
              // let date = new Date(this.selectTime)
              let title = `供货记录`
              let str = document.querySelector('.el-table__header').innerHTML
              let body = document.querySelector('.el-table__body').innerHTML
              let selectProduction = document.getElementById('productionSelect').value
              let selectSupplier = document.getElementById('supplierSelect').value
              let date = new Date(this.selectTime[0])
              let time = `${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`

              tableDataToExcelSample(str+body,title)
            },
            search(){
                this.getRecordList_()
            },

          getRecordList_(){
            this.selectOrderId = []
            this.orderIdArr = []
                if(!this.selectTime){
                    this.$message.error('请选择时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  productionId:this.productionId,
                  supplierId:this.supplierId,
                  specId: this.specId,
                  tecId: this.tecId
                }
            getSupplierRecord(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.tableData = res.data
                    }
                }).catch(() => {
                    this.listLoading = false
                })
          },
          selectionChange(val){
            this.selectRows = val
          },
        }
    }
</script>

<style lang="scss">
    .supplier-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
        .orderSelect{
            width: 300px !important;
        }
    }

</style>
